import appLayout from "@/layouts/side-nav-inner-toolbar"
import defaultLayout from './default'
import resetPasswordLayout from './reset-password'
import createAccountLayout from './create-account'

export { appLayout, defaultLayout, resetPasswordLayout, createAccountLayout }

export default { appLayout, defaultLayout, resetPasswordLayout, createAccountLayout }